import React, { FC } from "react";
import { Fade } from "react-awesome-reveal";
import classNames from "classnames";
import { DEFAULT_FADE_DURATION } from "@app/constants";
import { IconBox } from "./components/icon-box/IconBox";
import { IconBoxData } from "./components/icon-box/types";

type Props = {
  boxes: IconBoxData[];
};

export const IconBoxes: FC<Props> = ({ boxes }) => (
  <Fade duration={DEFAULT_FADE_DURATION} triggerOnce>
    <div
      className={classNames(
        "mt-20 grid grid-cols-1 gap-6 px-5",
        "md:grid-cols-2",
        "lg:mt-25 lg:px-16",
        "xl:mt-40 xl:grid-cols-3 xl:px-24",
        "xxl:mx-auto xxl:w-full xxl:max-w-container-wide",
      )}
    >
      {boxes.map((box) => (
        <IconBox key={box._uid} {...box} />
      ))}
    </div>
  </Fade>
);
